gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.stores-section__anchor').forEach(function (el) {
  var id = el.getAttribute('id');
  var title = el.getAttribute('data-title');
  var item = document.createElement('li');
  var link = document.createElement('a');
  var span = document.createElement('span');
  item.className = `${id}`;
  link.href = `#${id}`;
  span.innerText = title;
  link.appendChild(span);
  item.appendChild(link);
  document.querySelector('.stores-section__menu ul').appendChild(item);
});

$('.faq-category__toggle').on('click', function () {
  var $target = $(this).closest('.faq-main');
  $('.faq-main.active').not($target).removeClass('active');
  $target.toggleClass('active');
});

$('.stores-section__menu li:nth-child(2) a').addClass('active');

$('.stores-section__menu li a').on('click', function () {
  $('.stores-section__menu li a.active').removeClass('active');
  $(this).toggleClass('active');
  $('.stores-section__anchor').addClass('active');
});

ScrollTrigger.matchMedia({
  '(min-width: 992px)': function () {
    var offset = $('.header').height() + 30;
    // const offsetBottom = $('.faq-main__tab-links').height() + offset + 100;

    var ST = ScrollTrigger.create({
      trigger: '.stores-section__col--sticky',
      endTrigger: '.banner-container',
      start: `${-offset} top`,
      end: 'top bottom',
      pin: true,
      pinSpacing: false,
    });
  },
});
